
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.5 9.625h-33c-.76 0-1.375.616-1.375 1.375v22c0 .76.616 1.375 1.375 1.375h33c.76 0 1.375-.616 1.375-1.375V11c0-.76-.616-1.375-1.375-1.375zM28.874 28.875h5.5M20.624 28.875h2.75M4.124 16.646h35.75","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    